import { MQTTSubscriber } from '../mqtt/MQTTSubscriber';

export interface AppConfig {
    API_ENDPOINT: string;
    MQTT_BROKER_URL: string;
    STRIPE_PUBLISHABLE_KEY: string;
    STRIPE_PRICING_TABLE_ID: string;
    FRONTEND_URL: string;
}

// Development configuration
const devConfig: AppConfig = {
    API_ENDPOINT: "http://localhost:3030",
    MQTT_BROKER_URL: "wss://mqtt.omnilaw.ai/mqtt",
    STRIPE_PUBLISHABLE_KEY: "pk_test_51RlRuPHCTvENf3hp6bR62KXLjVhkuWXMX7CxIyeoAWShpe4R3JPhphapB31NeA3b7K102taToHfkiZETZ2D5sS0G00JSGbOSyR",
    STRIPE_PRICING_TABLE_ID: "prctbl_1RlUenHCTvENf3hpEh8lxBy8",
    FRONTEND_URL: "http://localhost:3000",
};

// Production configuration
const prodConfig: AppConfig = {
    API_ENDPOINT: "https://api.omnilaw.ai",
    MQTT_BROKER_URL: "wss://mqtt.omnilaw.ai/mqtt",
    STRIPE_PUBLISHABLE_KEY: "pk_live_51RlRuGHdO9mncnSNLkimlcx4uXWc50BCJwzUjsadSv5RNsaXjhCw2OcLn8A7Kl54lLyZyxbes1AUFB2vxUExEVKz006jVrDXM2",
    STRIPE_PRICING_TABLE_ID: "prctbl_1RmGEuHdO9mncnSNfnZkKXil",
    FRONTEND_URL: "https://app.omnilaw.ai",
};

// Determine which configuration to use
const environment = import.meta.env.VITE_ENVIRONMENT || import.meta.env.NODE_ENV || 'development';
const isProduction = environment === 'production' || environment === 'prod';

console.log(`Environment: ${environment}, Using ${isProduction ? 'production' : 'development'} config`);

// Select configuration based on environment
export let appConfig: AppConfig = isProduction ? prodConfig : devConfig;

// Allow individual overrides via environment variables (optional)
// This gives flexibility to override specific values without changing the environment
if (import.meta.env.VITE_API_ENDPOINT) {
    appConfig.API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;
}
if (import.meta.env.VITE_MQTT_BROKER_URL) {
    appConfig.MQTT_BROKER_URL = import.meta.env.VITE_MQTT_BROKER_URL;
}
if (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY) {
    appConfig.STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
}
if (import.meta.env.VITE_STRIPE_PRICING_TABLE_ID) {
    appConfig.STRIPE_PRICING_TABLE_ID = import.meta.env.VITE_STRIPE_PRICING_TABLE_ID;
}
if (import.meta.env.VITE_FRONTEND_URL) {
    appConfig.FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
}

console.log('Final app config:', appConfig);

// Make MQTTSubscriber accessible for debugging and status checks
if (typeof window !== 'undefined') {
    (window as any).MQTTSubscriber = MQTTSubscriber;
}